
import youtube from './images/youtube.svg';

const videos = [{
  icon: youtube,
  text: 'landing.skyware.watchNow.youtube.what',
  url: 'https://youtu.be/wG9Q3xzSPdI',
}, {
  icon: youtube,
  text: 'landing.skyware.watchNow.youtube.solution',
  url: 'https://youtu.be/8H3KR-Pf2Ks',
}, {
  icon: youtube,
  text: 'landing.skyware.watchNow.youtube.isp',
  url: 'https://youtu.be/CHquZrKlRtc',
}];

export default videos;



// WEBPACK FOOTER //
// ./src/components/SkywireLanding/videos.js